import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import UniversalGalleryEditor from 'components/editor/movies/gallery/galleryUniversal';

export default (props) => {
	if (isFocusStudio()) return null;
	return <UniversalGalleryEditor {...props} />;
};